import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';

import Home from '@/views/home/Home';
import Sig from '@/views/sig/SIG.vue';
import Pessoa from '@/views/pessoa/Pessoa';
import DiagnosticoSocioambiental from '@/views/diagnostico-socioambiental/DiagnosticoSocioambiental';
import DiagnosticoSocioambientalParaguai from '@/views/diagnostico-socioambiental/DiagnosticoSocioambientalParaguai';
import Laudos from '@/views/laudos/Laudos';
import Usuarios from '@/views/usuarios/Usuarios';
import Noticias from '@/views/noticias/Noticias';
import Inteligencia from '@/views/inteligencia/Inteligencia';
import CompartilhamentoDados from '@/views/compartilhamento-dados/CompartilhamentoDados';

import Territorio from '@/views/territorio/Territorio';
import TerritorioParaguai from '@/views/territorio/TerritorioParaguai.vue';
import CadastroTerritorio from '@/views/territorio/CadastroTerritorio';
import CadastroTerritorioParaguai from '@/views/territorio/CadastroTerritorioParaguai.vue';
import CadastroTerritorioVegaSemCar from '@/views/territorio/CadastroTerritorioVegaSemCar.vue';
import VisualizarTerritorio from '@/views/territorio/VisualizarTerritorio';
import VisualizarTerritorioParaguai from '@/views/territorio/VisualizarTerritorioParaguai';
import DiagnosticoSocioambientalTerritorio from '@/views/territorio/DiagnosticoSocioambientalTerritorio';

import Monitoramento from '@/views/monitoramento/Monitoramento';
import MonitoramentoAgricola from '@/views/monitoramento/agricola/MonitoramentoAgricola';
import MonitoramentoAgricolaParaguai from '@/views/monitoramento/agricola/MonitoramentoAgricolaParaguai';
import MonitoramentoSocioambiental from '@/views/monitoramento/socioambiental/MonitoramentoSocioambiental';
import CadastrarMonitoramentoAgricola from '@/views/monitoramento/agricola/CadastrarMonitoramentoAgricola';
import CadastrarMonitoramentoAgricolaParaguai from '@/views/monitoramento/agricola/CadastrarMonitoramentoAgricolaParaguai';
import VisualizarImovelMonitoramentoAgricola from '@/views/monitoramento/agricola/VisualizarImovelMonitoramentoAgricola';
import VisualizarImovelMonitoramentoAgricolaParaguai from '@/views/monitoramento/agricola/VisualizarImovelMonitoramentoAgricolaParaguai';

import AreaMonitorada from '@/views/monitoramento/AreaMonitorada';
import CadastrarMonitoramentoSocioAmbiental
    from '@/views/monitoramento/socioambiental/CadastrarMonitoramentoSocioAmbiental.vue';
import ListaTerritoriosImportados from '@/views/monitoramento/ListaTerritoriosImportados';
import VisualizarMonitoramentoSocioambiental
    from '@/views/monitoramento/socioambiental/VisualizarMonitoramentoSocioambiental';

import VisualizarInteligenciaCarbono from '@/views/inteligencia-carbono/VisualizarInteligenciaCarbono';
import VisualizarCarbonoImovel from '@/views/inteligencia-carbono/VisualizarCarbonoImovel';

import ListaOperacao from '@/views/operacao/Operacao';
import DashboardMonitoramento from '@/views/operacao/dashboard-monitoramento/DashboardMonitoramentoOperacao';
import ErrosMonitoramentoOperacaoBase from '@/views/operacao/dashboard-monitoramento/ErrosMonitoramentoOperacaoBase';
import RelatorioMonitoramentoOperacaoTerritorios
    from '@/views/operacao/dashboard-monitoramento/RelatorioMonitoramentoOperacaoTerritorios';
import MonitoramentoOperacao from '@/views/operacao/MonitoramentoOperacao';
import FiscalizacaoOperacao from '@/views/operacao/fiscalizacao/FiscalizacaoOperacao';
import DashboardOperacao from '@/views/operacao/DashboardOperacao';
import AnalisarOperacao from '@/views/operacao/AnalisarOperacao';
import CadastroOperacao from '@/views/operacao/CadastrarOperacao';
import VisualizarOperacao from '@/views/operacao/VisualizarOperacao';
import RastreabilidadeRaizen from '@/views/RastreabilidadeRaizen';
import OperacoesEmLote from '@/views/operacao/OperacoesEmLote';
import CadastroLoteDetalhes from '@/views/operacao/CadastroLoteDetalhes';
import InibicaoAlertasEmLote from '@/views/operacao/InibicaoAlertasEmLote';
import OperacoesAlteracaoEmLote from '@/views/operacao/OperacoesAlteracaoEmLote';
import CancelamentoOperacoesEmLote from '@/views/operacao/CancelamentoOperacoesEmLote';

import Relatorios from '@/views/admin/relatorios/Relatorios';

import PreAnaliseCredito from '@/views/pre-analise-credito/PreAnaliseCredito';

import VisualizarPreAnaliseCredito from '@/views/pre-analise-credito/VisualizarPreAnaliseCredito';
import InteligenciaTerritorial from '@/views/inteligencia-territorial/InteligenciaTerritorial';
import InteligenciaTerritorialImovel from '@/views/inteligencia-territorial/InteligenciaTerritorialImovel';
import { rotasOperacoesCdaWa } from './routes/OperacoesCdaWa';
import PSSC from '@/views/pssc/PSSC.vue';
import DashboardPssc from '@/views/pssc/Dashboard.vue';
import TerritorioPssc from '@/views/pssc/Territorio.vue';

// PSSC
import IncluirTerritorioPSSC from '@/views/pssc/IncluirTerritorio';

const vm = Vue.prototype;
var perfilParaguai = false;
var territorioVegaAccess = false;

Vue.use(Router);
const router = new Router({
    routes: [
        {
            path: '*',
            redirect: '/'
        },
        {
            path: '/',
            name: 'Home',
            meta: {
                roles: [
                    'ROLE_ADMINISTRATOR',
                    'ROLE_REGULAR',
                    'ROLE_OPERACAO_CADASTRANTE',
                    'ROLE_FEATURE_LAUDO'
                ]
            },
            component: perfilAnalista() ? Laudos : Home
        },
        {
            path: '/sig',
            name: 'SIG',
            meta: {
                roles: [
                    'ROLE_ADMINISTRATOR',
                    'ROLE_REGULAR',
                    'ROLE_OPERACAO_CADASTRANTE'
                ]
            },
            component: Sig
        },
        {
            path: '/pessoa/:cadastrar?',
            name: 'Pessoa',
            meta: {
                roles: [
                    'ROLE_ADMINISTRATOR',
                    'ROLE_REGULAR',
                    'ROLE_OPERACAO_CADASTRANTE'
                ]
            },
            component: Pessoa
        },
        {
            path: '/territorio',
            name: 'Territorio',
            meta: {
                roles: ['ROLE_ADMINISTRATOR', 'ROLE_REGULAR', 'ROLE_OPERACAO_CADASTRANTE']
            },
            component: Territorio,
            beforeEnter: (to, from, next) => {
                to.matched[0].components.default = perfilParaguai ? TerritorioParaguai : Territorio;
                next();
            }
        },
        {
            path: '/territorio/cadastrar-editar/:cadastrar?',
            name: 'CadastrarEditarTerritorio',
            meta: {
                roles: ['ROLE_ADMINISTRATOR', 'ROLE_REGULAR', 'ROLE_OPERACAO_CADASTRANTE']
            },
            component: CadastroTerritorio,
            beforeEnter: (to, from, next) => {
                to.matched[0].components.default = perfilParaguai
                    ? (territorioVegaAccess ? CadastroTerritorioVegaSemCar : CadastroTerritorioParaguai)
                    : CadastroTerritorio;
                next();
            }
        },
        {
            path: '/territorio/socioambiental/:idTerritorio',
            name: 'TerritorioSocioambiental',
            meta: {
                roles: [
                    'ROLE_ADMINISTRATOR',
                    'ROLE_REGULAR',
                    'ROLE_OPERACAO_CADASTRANTE'
                ]
            },
            component: DiagnosticoSocioambientalTerritorio
        },
        {
            path: '/territorio/:idTerritorio',
            name: 'VisualizarTerritorio',
            meta: {
                roles: [
                    'ROLE_ADMINISTRATOR',
                    'ROLE_REGULAR',
                    'ROLE_OPERACAO_CADASTRANTE'
                ]
            },
            component: VisualizarTerritorio,
            beforeEnter: (to, from, next) => {
                to.matched[0].components.default = perfilParaguai
                    ? VisualizarTerritorioParaguai
                    : VisualizarTerritorio;
                next();
            }
        },
        {
            path: '/diagnostico-socioambiental/:pesquisa?',
            name: 'DiagnosticoSocioambiental',
            meta: {
                roles: [
                    'ROLE_ADMINISTRATOR',
                    'ROLE_REGULAR',
                    'ROLE_OPERACAO_CADASTRANTE'
                ]
            },
            component: DiagnosticoSocioambiental,
            beforeEnter: (to, from, next) => {
                to.matched[0].components.default = perfilParaguai ? DiagnosticoSocioambientalParaguai : DiagnosticoSocioambiental;
                next();
            }
        },
        {
            path: '/v2/diagnostico-socioambiental/:pesquisa?',
            name: 'DiagnosticoSocioambientalV2',
            meta: {
                roles: [
                    'ROLE_ADMINISTRATOR',
                    'ROLE_REGULAR',
                    'ROLE_OPERACAO_CADASTRANTE'
                ]
            },
            component: () => import('@/views/diagnostico-socioambiental/v2/DiagnosticoSocioambientalV2.vue'),
            beforeEnter: (to, from, next) => {
                to.matched[0].components.default = perfilParaguai
                    ? DiagnosticoSocioambientalParaguai
                    : () => import('@/views/diagnostico-socioambiental/v2/DiagnosticoSocioambientalV2.vue');
                next();
            }
        },
        {
            path: '/laudo',
            redirect: 'dashboard',
            meta: {
                roles: [
                    'ROLE_ADMINISTRATOR',
                    'ROLE_ANALYST',
                    'ROLE_REGULAR',
                    'ROLE_OPERACAO_APROVADOR',
                    'ROLE_FEATURE_LAUDO'
                ]
            },
            component: Laudos,
            beforeEnter: (to, from, next) => {
                to.matched[0].components.default = perfilParaguai ? Home : Laudos;
                next();
            },
            children: [
                {
                    path: '',
                    name: 'Laudos',
                    meta: {
                        roles: [
                            'ROLE_ADMINISTRATOR',
                            'ROLE_REGULAR',
                            'ROLE_OPERACAO_APROVADOR'
                        ]
                    },
                    component: () =>
                        import(
                            '@/views/laudos/dashboard/LaudosDashboard'
                            )
                },
                {
                    path: 'dashboard',
                    name: 'LaudosDashboard',
                    meta: {
                        roles: [
                            'ROLE_ADMINISTRATOR',
                            'ROLE_REGULAR',
                            'ROLE_OPERACAO_APROVADOR',
                            'ROLE_FEATURE_LAUDO'
                        ]
                    },
                    component: () =>
                        import('@/views/laudos/dashboard/LaudosDashboard')
                },
                {
                    path: 'bacen-fiscalizacao',
                    meta: {
                        roles: [
                            'ROLE_ADMINISTRATOR',
                            'ROLE_REGULAR',
                            'ROLE_OPERACAO_APROVADOR'
                        ]
                    },
                    component: Laudos,
                    children: [
                        {
                            path: '',
                            name: 'LaudosBacenFiscalizacao',
                            meta: {
                                roles: [
                                    'ROLE_ADMINISTRATOR',
                                    'ROLE_REGULAR',
                                    'ROLE_OPERACAO_APROVADOR'
                                ]
                            },
                            component: () =>
                                import(
                                    '@/views/laudos/bacenFiscalizacao/LaudoBacenFiscalizacao'
                                )
                        },
                        {
                            path: 'solicitacao',
                            name: 'LaudoSolicitacaoBacenFiscalizacao',
                            meta: {
                                roles: [
                                    'ROLE_ADMINISTRATOR',
                                    'ROLE_REGULAR',
                                    'ROLE_OPERACAO_APROVADOR'
                                ]
                            },
                            component: () =>
                                import(
                                    '@/views/laudos/bacenFiscalizacao/SolicitarLaudo'
                                )
                        }
                    ]
                },
                {
                    path: 'benfeitorias',
                    meta: {
                        roles: [
                            'ROLE_ADMINISTRATOR',
                            'ROLE_REGULAR',
                            'ROLE_OPERACAO_APROVADOR'
                        ]
                    },
                    component: Laudos,
                    children: [
                        {
                            path: '',
                            name: 'LaudosBenfeitorias',
                            meta: {
                                roles: [
                                    'ROLE_ADMINISTRATOR',
                                    'ROLE_REGULAR',
                                    'ROLE_OPERACAO_APROVADOR'
                                ]
                            },
                            component: () =>
                                import(
                                    '@/views/laudos/benfeitorias/LaudoBenfeitorias'
                                )
                        },
                        {
                            path: 'solicitacao',
                            name: 'LaudoSolicitacaoBenfeitorias',
                            meta: {
                                roles: [
                                    'ROLE_ADMINISTRATOR',
                                    'ROLE_REGULAR',
                                    'ROLE_OPERACAO_APROVADOR'
                                ]
                            },
                            component: () =>
                                import(
                                    '@/views/laudos/benfeitorias/SolicitarLaudo'
                                )
                        }
                    ]
                },
                {
                    path: 'agricola',
                    meta: {
                        roles: [
                            'ROLE_ADMINISTRATOR',
                            'ROLE_REGULAR',
                            'ROLE_OPERACAO_APROVADOR'
                        ]
                    },
                    component: Laudos,
                    children: [
                        {
                            path: '',
                            name: 'LaudosAgricola',
                            meta: {
                                roles: [
                                    'ROLE_ADMINISTRATOR',
                                    'ROLE_REGULAR',
                                    'ROLE_OPERACAO_APROVADOR'
                                ]
                            },
                            component: () =>
                                import('@/views/laudos/agricola/LaudoAgricola')
                        }
                    ]
                },
                {
                    path: 'conformidade-ambiental',
                    meta: {
                        roles: [
                            'ROLE_ADMINISTRATOR',
                            'ROLE_REGULAR',
                            'ROLE_OPERACAO_APROVADOR',
                            'ROLE_FEATURE_LAUDO'
                        ]
                    },
                    component: Laudos,
                    children: [
                        {
                            path: '',
                            name: 'LaudosConformidadeAmbiental',
                            meta: {
                                roles: [
                                    'ROLE_ADMINISTRATOR',
                                    'ROLE_REGULAR',
                                    'ROLE_OPERACAO_APROVADOR',
                                    'ROLE_FEATURE_LAUDO'
                                ]
                            },
                            component: () =>
                                import(
                                    '@/views/laudos/conformidadeAmbiental/LaudoConformidadeAmbiental'
                                )
                        },
                        {
                            path: 'solicitacao/:territoriosIdsPesquisaInteligente?',
                            name: 'LaudoSolicitacaoConformidadeAmbiental',
                            meta: {
                                roles: [
                                    'ROLE_ADMINISTRATOR',
                                    'ROLE_REGULAR',
                                    'ROLE_OPERACAO_APROVADOR',
                                    'ROLE_FEATURE_LAUDO'
                                ]
                            },
                            component: () =>
                                import(
                                    '@/views/laudos/conformidadeAmbiental/SolicitarLaudo'
                                )
                        }
                    ]
                },
                {
                    path: 'renovabio',
                    meta: {
                        roles: [
                            'ROLE_ADMINISTRATOR',
                            'ROLE_REGULAR',
                            'ROLE_OPERACAO_APROVADOR'
                        ]
                    },
                    component: Laudos,
                    children: [
                        {
                            path: '',
                            name: 'LaudoRenovabio',
                            meta: {
                                roles: [
                                    'ROLE_ADMINISTRATOR',
                                    'ROLE_REGULAR',
                                    'ROLE_OPERACAO_APROVADOR'
                                ]
                            },
                            component: () =>
                                import(
                                    '@/views/laudos/renovabio/LaudoRenovabio'
                                )
                        },
                        {
                            path: 'solicitacao/:territoriosIdsPesquisaInteligente?',
                            name: 'LaudoSolicitacaoRenovabio',
                            meta: {
                                roles: [
                                    'ROLE_ADMINISTRATOR',
                                    'ROLE_REGULAR',
                                    'ROLE_OPERACAO_APROVADOR'
                                ]
                            },
                            component: () =>
                                import(
                                    '@/views/laudos/renovabio/SolicitarLaudo'
                                )
                        }
                    ]
                },
                {
                    path: 'carbono',
                    meta: {
                        roles: [
                            'ROLE_ADMINISTRATOR',
                            'ROLE_REGULAR',
                            'ROLE_OPERACAO_APROVADOR',
                            'ROLE_FEATURE_LAUDO'
                        ]
                    },
                    component: Laudos,
                    children: [
                        {
                            path: '',
                            name: 'LaudoCarbono',
                            meta: {
                                roles: [
                                    'ROLE_ADMINISTRATOR',
                                    'ROLE_REGULAR',
                                    'ROLE_OPERACAO_APROVADOR',
                                    'ROLE_FEATURE_LAUDO'
                                ]
                            },
                            component: () =>
                                import('@/views/laudos/carbono/LaudoCarbono')
                        }
                    ]
                },
                {
                    path: 'mut-pastagem',
                    meta: {
                        roles: [
                            'ROLE_ADMINISTRATOR',
                            'ROLE_REGULAR',
                            'ROLE_OPERACAO_APROVADOR',
                            'ROLE_FEATURE_LAUDO'
                        ]
                    },
                    component: Laudos,
                    children: [
                        {
                            path: '',
                            name: 'LaudoMutPastagem',
                            meta: {
                                roles: [
                                    'ROLE_ADMINISTRATOR',
                                    'ROLE_REGULAR',
                                    'ROLE_OPERACAO_APROVADOR',
                                    'ROLE_FEATURE_LAUDO'
                                ]
                            },
                            component: () =>
                                import('@/views/laudos/mutPastagem/LaudoMutPastagem')
                        }
                    ]
                },
                {
                    path: 'historico-agricola',
                    meta: {
                        roles: [
                            'ROLE_ADMINISTRATOR',
                            'ROLE_REGULAR',
                            'ROLE_OPERACAO_APROVADOR'
                        ]
                    },
                    component: Laudos,
                    children: [
                        {
                            path: '',
                            name: 'LaudoHistoricoAgricola',
                            meta: {
                                roles: [
                                    'ROLE_ADMINISTRATOR',
                                    'ROLE_REGULAR',
                                    'ROLE_OPERACAO_APROVADOR'
                                ]
                            },
                            component: () =>
                                import(
                                    '@/views/laudos/historicoAgricola/LaudoHistoricoAgricola'
                                )
                        }
                    ]
                },
                {
                    path: 'relatorio-territorial',
                    meta: {
                        roles: [
                            'ROLE_ADMINISTRATOR',
                            'ROLE_REGULAR',
                            'ROLE_OPERACAO_APROVADOR'
                        ]
                    },
                    component: Laudos,
                    children: [
                        {
                            path: '',
                            name: 'LaudoRelatorioTerritorial',
                            meta: {
                                roles: [
                                    'ROLE_ADMINISTRATOR',
                                    'ROLE_REGULAR',
                                    'ROLE_OPERACAO_APROVADOR'
                                ]
                            },
                            component: () =>
                                import(
                                    '@/views/laudos/relatorioTerritorial/LaudoRelatorioTerritorial'
                                )
                        }
                    ]
                },
                {
                    path: 'analise-cobertura-solo',
                    meta: {
                        roles: [
                            'ROLE_ADMINISTRATOR',
                            'ROLE_REGULAR',
                            'ROLE_OPERACAO_APROVADOR'
                        ]
                    },
                    component: Laudos,
                    children: [
                        {
                            path: '',
                            name: 'LaudoAnaliseCoberturaSolo',
                            meta: {
                                roles: [
                                    'ROLE_ADMINISTRATOR',
                                    'ROLE_REGULAR',
                                    'ROLE_OPERACAO_APROVADOR'
                                ]
                            },
                            component: () =>
                                import(
                                    '@/views/laudos/analiseCoberturaSolo/LaudoAnaliseCoberturaSolo'
                                )
                        }
                    ]
                },
                {
                    path: 'diagnostico-agricola',
                    meta: {
                        roles: [
                            'ROLE_ADMINISTRATOR',
                            'ROLE_REGULAR',
                            'ROLE_OPERACAO_APROVADOR'
                        ]
                    },
                    component: Laudos,
                    children: [
                        {
                            path: '',
                            name: 'LaudoDiagnosticoAgricola',
                            meta: {
                                roles: [
                                    'ROLE_ADMINISTRATOR',
                                    'ROLE_REGULAR',
                                    'ROLE_OPERACAO_APROVADOR'
                                ]
                            },
                            component: () =>
                                import(
                                    '@/views/laudos/diagnosticoAgricola/LaudoDiagnosticoAgricola'
                                )
                        }
                    ]
                },
                {
                    path: 'supressao-vegetal',
                    meta: {
                        roles: [
                            'ROLE_ADMINISTRATOR',
                            'ROLE_REGULAR',
                            'ROLE_OPERACAO_APROVADOR'
                        ]
                    },
                    component: Laudos,
                    children: [
                        {
                            path: '',
                            name: 'LaudoSupressaoVegetal',
                            meta: {
                                roles: [
                                    'ROLE_ADMINISTRATOR',
                                    'ROLE_REGULAR',
                                    'ROLE_OPERACAO_APROVADOR'
                                ]
                            },
                            component: () =>
                                import(
                                    '@/views/laudos/supressaoVegetal/LaudoSupressaoVegetal'
                                )
                        }
                    ]
                },
                {
                    path: 'tecnico-agricola',
                    meta: {
                        roles: [
                            'ROLE_ADMINISTRATOR',
                            'ROLE_REGULAR',
                            'ROLE_OPERACAO_APROVADOR'
                        ]
                    },
                    component: Laudos,
                    children: [
                        {
                            path: '',
                            name: 'LaudoTecnicoAgricola',
                            meta: {
                                roles: [
                                    'ROLE_ADMINISTRATOR',
                                    'ROLE_REGULAR',
                                    'ROLE_OPERACAO_APROVADOR'
                                ]
                            },
                            component: () =>
                                import(
                                    '@/views/laudos/tecnicoAgricola/LaudoTecnicoAgricola'
                                )
                        },
                        {
                            path: 'solicitacao',
                            name: 'LaudoSolicitacaoTecnicoAgricola',
                            meta: {
                                roles: [
                                    'ROLE_ADMINISTRATOR',
                                    'ROLE_REGULAR',
                                    'ROLE_OPERACAO_APROVADOR'
                                ]
                            },
                            component: () =>
                                import(
                                    '@/views/laudos/tecnicoAgricola/SolicitarLaudo'
                                )
                        }
                    ]
                },
                {
                    path: 'croqui',
                    meta: {
                        roles: [
                            'ROLE_ADMINISTRATOR',
                            'ROLE_REGULAR',
                            'ROLE_OPERACAO_APROVADOR'
                        ]
                    },
                    component: Laudos,
                    children: [
                        {
                            path: '',
                            name: 'LaudoCroqui',
                            meta: {
                                roles: [
                                    'ROLE_ADMINISTRATOR',
                                    'ROLE_REGULAR',
                                    'ROLE_OPERACAO_APROVADOR'
                                ]
                            },
                            component: () =>
                                import('@/views/laudos/croqui/LaudoCroqui')
                        },
                        {
                            path: 'solicitacao',
                            name: 'LaudoSolicitacaoCroqui',
                            meta: {
                                roles: [
                                    'ROLE_ADMINISTRATOR',
                                    'ROLE_REGULAR',
                                    'ROLE_OPERACAO_APROVADOR'
                                ]
                            },
                            component: () =>
                                import('@/views/laudos/croqui/SolicitarLaudo')
                        }
                    ]
                },
                {
                    path: 'bacen-resolucao-140',
                    meta: {
                        roles: [
                            'ROLE_ADMINISTRATOR',
                            'ROLE_REGULAR',
                            'ROLE_OPERACAO_APROVADOR'
                        ]
                    },
                    component: Laudos,
                    children: [
                        {
                            path: '',
                            name: 'LaudoBacenResolucao140',
                            meta: {
                                roles: [
                                    'ROLE_ADMINISTRATOR',
                                    'ROLE_REGULAR',
                                    'ROLE_OPERACAO_APROVADOR'
                                ]
                            },
                            component: () =>
                                import(
                                    '@/views/laudos/bacenResolucao140/LaudoBacenResolucao'
                                )
                        },
                        {
                            path: 'solicitacao',
                            name: 'LaudoSolicitacaoBacenResolucao140',
                            meta: {
                                roles: [
                                    'ROLE_ADMINISTRATOR',
                                    'ROLE_REGULAR',
                                    'ROLE_OPERACAO_APROVADOR'
                                ]
                            },
                            component: () =>
                                import(
                                    '@/views/laudos/bacenResolucao140/SolicitarLaudo'
                                )
                        }
                    ]
                },
                {
                    path: 'avaliacao-fundiaria',
                    meta: {
                        roles: [
                            'ROLE_ADMINISTRATOR',
                            'ROLE_REGULAR',
                            'ROLE_OPERACAO_APROVADOR'
                        ]
                    },
                    component: Laudos,
                    children: [
                        {
                            path: '',
                            name: 'LaudoAvaliacaoFundiarias',
                            meta: {
                                roles: [
                                    'ROLE_ADMINISTRATOR',
                                    'ROLE_REGULAR',
                                    'ROLE_OPERACAO_APROVADOR'
                                ]
                            },
                            component: () =>
                                import(
                                    '@/views/laudos/avaliacaoFundiaria/LaudoAvaliacaoFundiarias'
                                )
                        },
                        {
                            path: 'solicitacao',
                            name: 'LaudoSolicitacaoAvaliacaoFundiarias',
                            meta: {
                                roles: [
                                    'ROLE_ADMINISTRATOR',
                                    'ROLE_REGULAR',
                                    'ROLE_OPERACAO_APROVADOR'
                                ]
                            },
                            component: () =>
                                import(
                                    '@/views/laudos/avaliacaoFundiaria/SolicitarLaudo'
                                )
                        }
                    ]
                },
                {
                    path: 'avaliacao-area-produtiva',
                    meta: {
                        roles: [
                            'ROLE_ADMINISTRATOR',
                            'ROLE_REGULAR',
                            'ROLE_OPERACAO_APROVADOR'
                        ]
                    },
                    component: Laudos,
                    children: [
                        {
                            path: '',
                            name: 'LaudoAvaliacaoAreaProdutiva',
                            meta: {
                                roles: [
                                    'ROLE_ADMINISTRATOR',
                                    'ROLE_REGULAR',
                                    'ROLE_OPERACAO_APROVADOR'
                                ]
                            },
                            component: () =>
                                import(
                                    '@/views/laudos/avaliacaoAreaProdutiva/LaudoAvaliacaoAreaProdutiva'
                                )
                        }
                    ]
                },
                {
                    path: 'avaliacao-socioambiental',
                    meta: {
                        roles: [
                            'ROLE_ADMINISTRATOR',
                            'ROLE_REGULAR',
                            'ROLE_OPERACAO_APROVADOR',
                            'ROLE_FEATURE_LAUDO'
                        ]
                    },
                    component: Laudos,
                    children: [
                        {
                            path: '',
                            name: 'LaudoAvaliacaoSocioambiental',
                            meta: {
                                roles: [
                                    'ROLE_ADMINISTRATOR',
                                    'ROLE_REGULAR',
                                    'ROLE_OPERACAO_APROVADOR',
                                    'ROLE_FEATURE_LAUDO'
                                ]
                            },
                            component: () =>
                                import(
                                    '@/views/laudos/avaliacaoSocioambiental/LaudoAvaliacaoSocioambiental'
                                )
                        }
                    ]
                }
            ]
        },
        {
            path: '/usuarios',
            name: 'Usuarios',
            meta: {
                roles: ['ROLE_ADMINISTRATOR', 'ROLE_FEATURE_LAUDO']
            },
            component: Usuarios
        },
        {
            path: '/noticias',
            name: 'Noticias',
            meta: {
                roles: ['ROLE_VEGA_ADMIN']
            },
            component: Noticias
        },
        {
            path: '/monitoramento',
            name: 'Monitoramento',
            meta: {
                roles: [
                    'ROLE_ADMINISTRATOR',
                    'ROLE_FEATURE_MONITORAMENTO',
                    'ROLE_REGULAR'
                ]
            },
            component: Monitoramento
        },
        {
            path: '/monitoramento/area-monitorada/:idAreaMonitorada',
            name: 'AreaMonitorada',
            meta: {
                roles: [
                    'ROLE_ADMINISTRATOR',
                    'ROLE_MONITORAMENTO_AGRICOLA',
                    'ROLE_MONITORAMENTO_SOCIOAMBIENTAL',
                    'ROLE_FEATURE_MONITORAMENTO',
                    'ROLE_REGULAR'
                ]
            },
            component: AreaMonitorada
        },
        {
            path: '/monitoramento/socioambiental/:periodoAlertaSocioambiental?',
            name: 'MonitoramentoSocioambiental',
            meta: {
                roles: [
                    'ROLE_ADMINISTRATOR',
                    'ROLE_REGULAR',
                    'ROLE_MONITORAMENTO_SOCIOAMBIENTAL'
                ]
            },
            component: MonitoramentoSocioambiental
        },
        {
            path: '/monitoramento/socioambiental/area/:idAreaMonitorada/:voltarHome?',
            name: 'VisualizarMonitoramentoSocioambiental',
            meta: {
                roles: [
                    'ROLE_ADMINISTRATOR',
                    'ROLE_MONITORAMENTO_SOCIOAMBIENTAL',
                    'ROLE_REGULAR'
                ]
            },
            component: VisualizarMonitoramentoSocioambiental
        },
        {
            path: '/monitoramento/agricola/cadastrar/:valor?/:id?',
            name: 'CadastrarMonitoramentoAgricola',
            meta: {
                roles: [
                    'ROLE_ADMINISTRATOR',
                    'ROLE_MONITORAMENTO_AGRICOLA',
                    'ROLE_REGULAR'
                ]
            },
            component: CadastrarMonitoramentoAgricola,
            beforeEnter: (to, from, next) => {
                const usuario = store.state.usuarioLogado;
                if (usuario.monitoramentoAgricolaAccess === false || !usuario.monitoramentoAgricolaAccess) {
                    router.push({ name: 'Home' });
                }
                to.matched[0].components.default = perfilParaguai ? CadastrarMonitoramentoAgricolaParaguai : CadastrarMonitoramentoAgricola;
                next();
            }
        },
        {
            path: '/monitoramento/agricola/:id/imovel',
            name: 'MonitoramentoAgricolaImovel',
            meta: {
                roles: [
                    'ROLE_ADMINISTRATOR',
                    'ROLE_REGULAR',
                    'ROLE_FEATURE_COMPARTILHAMENTO_DADOS'
                ]
            },
            component: VisualizarImovelMonitoramentoAgricola,
            beforeEnter: (to, from, next) => {
                const usuario = store.state.usuarioLogado;
                if (usuario.monitoramentoAgricolaAccess === false || !usuario.monitoramentoAgricolaAccess) {
                    router.push({ name: 'Home' });
                }
                to.matched[0].components.default = perfilParaguai ? VisualizarImovelMonitoramentoAgricolaParaguai : VisualizarImovelMonitoramentoAgricola;
                next();
            }
        },
        {
            path: '/monitoramento/agricola/:periodoAlertaAgricola?',
            name: 'MonitoramentoAgricola',
            meta: {
                roles: [
                    'ROLE_ADMINISTRATOR',
                    'ROLE_REGULAR',
                    'ROLE_MONITORAMENTO_AGRICOLA'
                ]
            },
            component: MonitoramentoAgricola,
            beforeEnter: (to, from, next) => {
                const usuario = store.state.usuarioLogado;
                if (usuario.monitoramentoAgricolaAccess === false || !usuario.monitoramentoAgricolaAccess) {
                    router.push({ name: 'Home' });
                }
                to.matched[0].components.default = perfilParaguai ? MonitoramentoAgricolaParaguai : MonitoramentoAgricola;
                next();
            }
        },
        {
            path: '/monitoramento/socioambiental/cadastrar/:valor?/:id?',
            name: 'CadastrarMonitoramentoSocioAmbiental',
            meta: {
                roles: [
                    'ROLE_ADMINISTRATOR',
                    'ROLE_MONITORAMENTO_SOCIOAMBIENTAL',
                    'ROLE_REGULAR'
                ]
            },
            component: CadastrarMonitoramentoSocioAmbiental
        },
        {
            path: '/inteligencia',
            name: 'Inteligencia',
            meta: {
                roles: [
                    'ROLE_INTELIGENCIA',
                    'ROLE_ADMINISTRATOR',
                    'ROLE_REGULAR'
                ]
            },
            component: Inteligencia
        },
        {
            path: '/visualizar-inteligencia-carbono',
            name: 'InteligenciaCarbono',
            meta: {
                roles: [
                    'ROLE_INTELIGENCIA',
                    'ROLE_ADMINISTRATOR',
                    'ROLE_REGULAR'
                ]
            },
            component: VisualizarInteligenciaCarbono
        },
        {
            path: '/compartilhamento-dados',
            name: 'CompartilhamentoDados',
            meta: {
                roles: [
                    'ROLE_ADMINISTRATOR',
                    'ROLE_REGULAR',
                    'ROLE_FEATURE_COMPARTILHAMENTO_DADOS'
                ]
            },
            component: CompartilhamentoDados
        },
        {
            path: '/compartilhamento-dados/solicitacao',
            name: 'CompartilhamentoDadosSolicitacao',
            meta: {
                roles: [
                    'ROLE_ADMINISTRATOR',
                    'ROLE_REGULAR',
                    'ROLE_FEATURE_COMPARTILHAMENTO_DADOS'
                ]
            },
            component: () =>
                import('@/components/compartilhamentoDados/SolicitarRelatorio')
        },
        {
            path: '/operacao',
            name: 'operacao',
            meta: {
                roles: [
                    'ROLE_FEATURE_OPERACAO',
                    'ROLE_OPERACAO_CADASTRANTE',
                    'ROLE_OPERACAO_APROVADOR'
                ]
            },
            component: ListaOperacao
        },
        {
            path: '/dashboard-monitoramento',
            name: 'dashboardMonitoramento',
            meta: {
                roles: ['ROLE_FEATURE_OPERACAO', 'ROLE_ADMINISTRATOR'],
                hasAllRoles: true
            },
            component: DashboardMonitoramento
        },
        {
            path: '/erros/base',
            name: 'errosMonitoramentoOperacaoBase',
            meta: {
                roles: [
                    'ROLE_FEATURE_OPERACAO',
                    'ROLE_OPERACAO_CADASTRANTE',
                    'ROLE_OPERACAO_APROVADOR'
                ]
            },
            component: ErrosMonitoramentoOperacaoBase
        },
        {
            path: '/detalhes/monitoramento',
            name: 'relatorioMonitoramentoOperacaoTerritorios',
            meta: {
                roles: [
                    'ROLE_FEATURE_OPERACAO',
                    'ROLE_OPERACAO_CADASTRANTE',
                    'ROLE_OPERACAO_APROVADOR'
                ]
            },
            component: RelatorioMonitoramentoOperacaoTerritorios
        },
        {
            path: '/operacao/fiscalizacao',
            name: 'operacaoFiscalizacao',
            meta: {
                roles: [
                    'ROLE_FEATURE_FISCALIZACAO_OPERACAO',
                    'ROLE_ADMINISTRATOR'
                ],
                hasAllRoles: true
            },
            component: FiscalizacaoOperacao
        },
        {
            path: '/operacao/cadastrar',
            name: 'operacaoCadastrar',
            meta: {
                roles: [
                    'ROLE_FEATURE_OPERACAO',
                    'ROLE_OPERACAO_CADASTRANTE',
                    'ROLE_OPERACAO_APROVADOR'
                ]
            },
            component: CadastroOperacao
        },
        {
            path: '/operacao/dashboard',
            name: 'operacaoDashboard',
            meta: {
                roles: ['ROLE_ADMINISTRATOR', 'ROLE_FEATURE_OPERACAO'],
                hasAllRoles: true
            },
            component: DashboardOperacao
        },
        {
            path: '/operacao/lote',
            name: 'operacaoLote',
            meta: {
                roles: [
                    'ROLE_FEATURE_OPERACAO',
                    'ROLE_OPERACAO_CADASTRANTE',
                    'ROLE_OPERACAO_APROVADOR'
                ]
            },
            component: OperacoesEmLote
        },
        {
            path: '/operacao/lote/:id',
            name: 'operacaoLoteDetalhes',
            meta: {
                roles: [
                    'ROLE_FEATURE_OPERACAO',
                    'ROLE_OPERACAO_CADASTRANTE',
                    'ROLE_OPERACAO_APROVADOR'
                ]
            },
            component: CadastroLoteDetalhes
        },
        {
            path: '/operacao/inibicao-lote',
            name: 'operacaoInibicaoLote',
            meta: {
                roles: [
                    'ROLE_FEATURE_OPERACAO',
                    'ROLE_OPERACAO_CADASTRANTE',
                    'ROLE_OPERACAO_APROVADOR'
                ]
            },
            component: InibicaoAlertasEmLote
        },
        {
            path: '/operacao/cancelamento-lote',
            name: 'operacaoCancelamentoLote',
            meta: {
                roles: [
                    'ROLE_FEATURE_OPERACAO',
                    'ROLE_OPERACAO_CADASTRANTE',
                    'ROLE_OPERACAO_APROVADOR'
                ]
            },
            component: CancelamentoOperacoesEmLote
        },
        {
            path: '/operacao/alteracao-lote',
            name: 'operacaoAlteracaoLote',
            meta: {
                roles: [
                    'ROLE_FEATURE_OPERACAO',
                    'ROLE_OPERACAO_CADASTRANTE',
                    'ROLE_OPERACAO_APROVADOR'
                ]
            },
            component: OperacoesAlteracaoEmLote
        },
        {
            path: '/operacao/:id',
            name: 'operacaoVisualizar',
            meta: {
                roles: [
                    'ROLE_FEATURE_OPERACAO',
                    'ROLE_OPERACAO_CADASTRANTE',
                    'ROLE_OPERACAO_APROVADOR'
                ]
            },
            component: VisualizarOperacao
        },
        {
            path: '/operacao/:id/editar',
            name: 'operacaoEditar',
            meta: {
                roles: [
                    'ROLE_FEATURE_OPERACAO',
                    'ROLE_OPERACAO_CADASTRANTE',
                    'ROLE_OPERACAO_APROVADOR'
                ]
            },
            component: CadastroOperacao
        },
        {
            path: '/operacao/:id/clonar',
            name: 'operacaoClonar',
            meta: {
                roles: [
                    'ROLE_FEATURE_OPERACAO',
                    'ROLE_OPERACAO_CADASTRANTE',
                    'ROLE_OPERACAO_APROVADOR'
                ]
            },
            component: CadastroOperacao
        },
        {
            path: '/operacao/:id/analisar',
            name: 'operacaoAnalisar',
            meta: {
                roles: ['ROLE_FEATURE_OPERACAO', 'ROLE_OPERACAO_APROVADOR']
            },
            component: AnalisarOperacao
        },
        {
            path: '/operacao/:id/monitoramento',
            name: 'operacaoMonitoramento',
            meta: {
                roles: ['ROLE_FEATURE_OPERACAO', 'ROLE_OPERACAO_APROVADOR']
            },
            component: MonitoramentoOperacao
        },
        {
            path: '/admin/relatorios',
            name: 'adminRelatorios',
            meta: {
                roles: ['ROLE_VEGA_ADMIN']
            },
            component: Relatorios
        },
        {
            path: '/visualizar-carbono-imovel',
            name: 'CarbonoImovel',
            meta: {
                roles: [
                    'ROLE_INTELIGENCIA',
                    'ROLE_ADMINISTRATOR',
                    'ROLE_REGULAR'
                ]
            },
            component: VisualizarCarbonoImovel
        },
        {
            path: '/lista-territorios-importados',
            name: 'ListaTerritoriosImportados',
            meta: {
                roles: ['ROLE_ADMINISTRATOR', 'ROLE_REGULAR']
            },
            component: ListaTerritoriosImportados
        },
        {
            path: '/editar-atalhos',
            name: 'EditarAtalhos',
            meta: {
                roles: [
                    'ROLE_ADMINISTRATOR',
                    'ROLE_REGULAR',
                    'ROLE_OPERACAO_CADASTRANTE'
                ]
            },
            component: () =>
                import('@/components/home/acessoRapido/EditarAtalhos')
        },
        {
            path: '/rastreabilidade/empresa',
            meta: {
                roles: ['ROLE_FEATURE_RASTREABILIDADE_EMPRESA']
            },
            component: () =>
                import(
                    /* webpackChunkName: "DefaultRouterView" */ '@/views/DefaultRouterView'
                ),
            children: [
                {
                    path: '',
                    name: 'RastreabilidadeEmpresa',
                    meta: {
                        roles: ['ROLE_FEATURE_RASTREABILIDADE_EMPRESA']
                    },
                    component: () =>
                        import(
                            /* webpackChunkName: "GestaoContratosOriginacaoEmpresa" */ '@/views/contratos-originacao/GestaoContratosOriginacaoEmpresa'
                        )
                },
                {
                    path: 'contratos-originacao/cadastrar',
                    name: 'CadastrarContratoOriginacaoEmpresa',
                    meta: {
                        roles: ['ROLE_FEATURE_RASTREABILIDADE_EMPRESA']
                    },
                    component: () =>
                        import(
                            /* webpackChunkName: "ContratoOriginacao" */ '@/views/contratos-originacao/CadastroContratosOriginacaoEmpresa'
                        )
                },
                {
                    path: 'contratos-originacao/:id',
                    name: 'VisualizarContratoOriginacaoEmpresa',
                    meta: {
                        roles: ['ROLE_FEATURE_RASTREABILIDADE_EMPRESA']
                    },
                    component: () =>
                        import(
                            /* webpackChunkName: "ContratoOriginacao" */ '@/views/contratos-originacao/VisualizarContratoOriginacaoEmpresa'
                        )
                }
            ]
        },
        {
            path: '/rastreabilidade/subempresa',
            meta: {
                roles: ['ROLE_FEATURE_RASTREABILIDADE_SUB_EMPRESA']
            },
            component: () =>
                import(
                    /* webpackChunkName: "DefaultRouterView" */ '@/views/DefaultRouterView'
                ),
            children: [
                {
                    path: '',
                    name: 'RastreabilidadeSubEmpresa',
                    meta: {
                        roles: ['ROLE_FEATURE_RASTREABILIDADE_SUB_EMPRESA']
                    },
                    component: () =>
                        import(
                            /* webpackChunkName: "ContratoOriginacao" */ '@/views/contratos-originacao/GestaoContratosOriginacaoSubEmpresa'
                        )
                },

                {
                    path: 'contrato/:numeroContrato',
                    name: 'PreencherContratoOriginacao',
                    meta: {
                        roles: ['ROLE_FEATURE_RASTREABILIDADE_SUB_EMPRESA']
                    },
                    component: () =>
                        import(
                            /* webpackChunkName: "PreencherContratoOriginacao" */ '@/views/contrato/PreencherContratoOriginacao'
                        )
                },

                {
                    path: 'visualizar-processamento/:numeroContrato',
                    name: 'VisualizarProcessamentoContratoOriginacao',
                    meta: {
                        roles: ['ROLE_FEATURE_RASTREABILIDADE_SUB_EMPRESA']
                    },
                    component: () =>
                        import(
                            /* webpackChunkName: "ContratoOriginacao" */ '@/views/contrato/VisualizarProcessamento'
                        )
                }
            ]
        },
        {
            path: '/raizen',
            meta: {
                roles: [
                    'ROLE_ADMINISTRATOR',
                    'ROLE_FEATURE_MONITORAMENTO',
                    'ROLE_REGULAR'
                ]
            },
            component: RastreabilidadeRaizen,
            children: [
                {
                    path: '',
                    name: 'RastreabilidadeRaizen',
                    meta: {
                        roles: [
                            'ROLE_ADMINISTRATOR',
                            'ROLE_FEATURE_MONITORAMENTO',
                            'ROLE_REGULAR'
                        ]
                    },
                    component: () =>
                        import(
                            /* webpackChunkName: "Rastreabilidade" */ '@/views/rastreabilidadeRaizen/Rastreabilidade'
                        )
                },
                {
                    path: '/raizen/rastreabilidade/ordem-de-corte',
                    name: 'OrdemDeCorte',
                    meta: {
                        roles: [
                            'ROLE_ADMINISTRATOR',
                            'ROLE_FEATURE_MONITORAMENTO',
                            'ROLE_REGULAR'
                        ]
                    },
                    component: () =>
                        import(
                            /* webpackChunkName: "OrdemDeCorte" */ '@/views/rastreabilidadeRaizen/ordemDeCorte/OrdemDeCorte'
                        )
                },
                {
                    path: '/raizen/rastreabilidade/nota-de-pesagem',
                    name: 'NotaDePesagem',
                    meta: {
                        roles: [
                            'ROLE_ADMINISTRATOR',
                            'ROLE_FEATURE_MONITORAMENTO',
                            'ROLE_REGULAR'
                        ]
                    },
                    component: () =>
                        import(
                            /* webpackChunkName: "NotaDePesagem" */ '@/views/rastreabilidadeRaizen/notaDePesagem/NotaDePesagem'
                        )
                },
                {
                    path: '/raizen/rastreabilidade/nota-fiscal',
                    name: 'NotaFiscal',
                    meta: {
                        roles: [
                            'ROLE_ADMINISTRATOR',
                            'ROLE_FEATURE_MONITORAMENTO',
                            'ROLE_REGULAR'
                        ]
                    },
                    component: () =>
                        import(
                            /* webpackChunkName: "NotaFiscal" */ '@/views/rastreabilidadeRaizen/notaFiscal/NotaFiscal'
                        )
                },
                {
                    path: '/raizen/rastreabilidade/lote-de-producao',
                    name: 'LoteDeProducao',
                    meta: {
                        roles: [
                            'ROLE_ADMINISTRATOR',
                            'ROLE_FEATURE_MONITORAMENTO',
                            'ROLE_REGULAR'
                        ]
                    },
                    component: () =>
                        import(
                            /* webpackChunkName: "LoteDeProducao" */ '@/views/rastreabilidadeRaizen/loteDeProducao/LoteDeProducao'
                        )
                },
                {
                    path: '/raizen/rastreabilidade/visao-geral-fazenda/:codigoFazenda',
                    name: 'VisaoGeralFazenda',
                    meta: {
                        roles: [
                            'ROLE_ADMINISTRATOR',
                            'ROLE_FEATURE_MONITORAMENTO',
                            'ROLE_REGULAR'
                        ]
                    },
                    component: () =>
                        import(
                            /* webpackChunkName: "VisaoGeralFazenda" */ '@/views/rastreabilidadeRaizen/VisaoGeralFazenda'
                        )
                },
                {
                    path: '/raizen/rastreabilidade/visualizar-nota-fiscal',
                    name: 'VisualizarNotaFiscal',
                    meta: {
                        roles: [
                            'ROLE_ADMINISTRATOR',
                            'ROLE_FEATURE_MONITORAMENTO',
                            'ROLE_REGULAR'
                        ]
                    },
                    component: () =>
                        import(
                            /* webpackChunkName: "VisualizarNotaFiscal" */ '@/views/rastreabilidadeRaizen/notaFiscal/VisualizarNotaFiscal'
                        )
                }
            ]
        },
        {
            path: '/pre-analise-credito',
            name: 'PreAnaliseCredito',
            meta: {
                roles: ['ROLE_FEATURE_PRE_ANALISE_CREDITO']
            },
            component: PreAnaliseCredito
        },
        {
            path: '/pre-analise-credito/:cpfCnpj',
            name: 'VisualizarPreAnaliseCredito',
            meta: {
                roles: ['ROLE_FEATURE_PRE_ANALISE_CREDITO']
            },
            component: VisualizarPreAnaliseCredito
        },
        {
            path: '/inteligencia-territorial',
            name: 'InteligenciaTerritorial',
            meta: {
                roles: ['ROLE_FEATURE_INTELIGENCIA_TERRITORIAL']
            },
            component: InteligenciaTerritorial,
            children: [
                {
                    path: '/inteligencia-territorial/:uf',
                    name: 'InteligenciaTerritorialComUf',
                    meta: {
                        roles: ['ROLE_FEATURE_INTELIGENCIA_TERRITORIAL']
                    },
                    component: InteligenciaTerritorial
                },
                {
                    path: '/inteligencia-territorial/:uf/:municipio',
                    name: 'InteligenciaTerritorialComMunicipio',
                    meta: {
                        roles: ['ROLE_FEATURE_INTELIGENCIA_TERRITORIAL']
                    },
                    component: InteligenciaTerritorial
                }
            ]
        },
        {
            path: '/inteligencia-territorial-imovel/:uf/:codMunicipioIbge/:car',
            name: 'InteligenciaTerritorialImovel',
            meta: {
                roles: ['ROLE_FEATURE_INTELIGENCIA_TERRITORIAL']
            },
            component: InteligenciaTerritorialImovel
        },
        {
            path: '/pssc',
            name: 'PSSC',
            meta: {
                roles: ['ROLE_FEATURE_PSSC']
            },
            component: PSSC
        },
        {
            path: '/pssc',
            name: 'GestaoLotesPssc',
            meta: {
                roles: ['ROLE_FEATURE_PSSC']
            },
            component: PSSC
        },
        {
            path: '/pssc/dashboard',
            name: 'DashboardPssc',
            meta: {
                roles: ['ROLE_FEATURE_PSSC']
            },
            component: DashboardPssc
        },
        {
            path: '/pssc/territorio/:incluir?',
            name: 'IncluirTerritorioPSSC',
            meta: {
                roles: ['ROLE_FEATURE_PSSC']
            },
            component: IncluirTerritorioPSSC
        },
        {
            path: '/pssc/visao-geral-territorio/:territorio',
            name: 'TerritorioPssc',
            meta: {
                roles: ['ROLE_FEATURE_PSSC']
            },
            component: TerritorioPssc
        },
        ...rotasOperacoesCdaWa
    ]
});

function perfilAnalista() {
    let user = sessionStorage.getItem('dadosUsuario');
    if (user && user !== 'null') {
        user = JSON.parse(user);
        return user.isAnalyst;
    }

    return false;
}

router.beforeEach((to, from, next) => {
    if (from.fullPath === '/sig') {
        window.stop();
    }
    Vue.prototype.keycloak
        .updateToken(30)
        .then(() => {
            const usuarioLogado = store.getters['usuarioLogado'];

            if (usuarioLogado.isLaudo) {
                usuarioLogado.authorities = usuarioLogado.authorities.map(
                    item => {
                        if (item.authority === 'ROLE_FEATURE_LAUDO') {
                            return item;
                        }
                    }
                );
                usuarioLogado.authorities = usuarioLogado.authorities.filter(
                    item => item !== undefined
                );
                usuarioLogado.preAnaliseCreditoAccess = false;
                usuarioLogado.sentinelHubAccess = false;
                usuarioLogado.monitoramentoSocioambientalAccess = false;
                usuarioLogado.monitoramentoAgricolaAccess = false;
            }
            if (usuarioLogado.paisGrupo === 'PY') {
                perfilParaguai = true;
                if (usuarioLogado.territorioVegaAccess) {
                    territorioVegaAccess = true;
                }
                usuarioLogado.authorities = usuarioLogado.authorities.filter(
                    item => item !== undefined
                );
            } else {
                perfilParaguai = false;
                territorioVegaAccess = false;
            }

            let isAllowed = false;

            // Se caso tiver o parâmetro hasAllRoles valida se possui todas as roles especificadas para acessar a rota
            if (
                to.matched[0].meta.hasAllRoles !== 'undefined' &&
                to.matched[0].meta.hasAllRoles
            ) {
                const roles = usuarioLogado.authorities.map(
                    authority => authority.authority
                );
                if (
                    to.matched[0].meta.roles.every(role => {
                        return roles.includes(role);
                    })
                ) {
                    isAllowed = true;
                } else {
                    return next('/');
                }
            } else {
                usuarioLogado.authorities.forEach(role => {
                    if (
                        to.matched.some(route => {
                            return route.meta.roles.includes(role.authority);
                        })
                    ) {
                        isAllowed = true;
                    }
                });
            }

            if (process.env.NODE_ENV === 'production' && isAllowed) {
                if (vm) {
                    vm.$gtag.pageview(to.name);
                }
            }

            return next(isAllowed);
        })
        .catch(() => {
            next('/');
        });
});

export default router;
